import { configureStore, combineReducers, getDefaultMiddleware } from "@reduxjs/toolkit";
import themeReducer from "./themeSlice";
import loggedUserSlice from "./loggedUserSlice";
import userRoutesSlice from "./userRoutesSlice";
// Use session storage to reduce quota issues in the browser.
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";

// Persist only the small slices to avoid storage quota issues.
const persistConfig = {
  key: "root_v2",
  storage: sessionStorage,
  // Persist only the minimal slice to avoid exceeding storage quota.
  whitelist: ["theme"],
};

const rootReducer = combineReducers({
  theme: themeReducer,
  user: loggedUserSlice,
  routes: userRoutesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      // Ignore redux-persist non-serializable actions/paths
      ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/REGISTER"],
      ignoredPaths: ["register"],
    },
    immutableCheck: false,
  }),
});

export const persistor = persistStore(store);